
export default {
  data: function data() {
    return {
      config: {},
      isExpanded: false
    };
  },
  methods: {
    init: function init(config) {
      this.config = config || {};
      this.isExpanded = !!this.config.initIsExpanded;
    },
    toggleIsExpanded: function toggleIsExpanded(event) {
      this.isExpanded = !this.isExpanded;
      var eventName = this.isExpanded ? this.config.expandEventName : this.config.collapseEventName;
      if (eventName && GeneralMills.Analytics) GeneralMills.Analytics.raiseEvent({
        EventType: eventName
      });
    }
  }
};